// recovery-manifest-io.ts
//
// Tách THUẦN từ recovery-reconciler.ts (phase 10, lô A): đường dẫn + đọc/ghi
// manifest recovery (leaf — chỉ I/O, không chứa máy trạng thái phase).

import { promises as fs } from "node:fs";
import { dirname, join } from "node:path";
import { type DurableFsOps, writeFileDurable } from "./durable-file-writer.js";

export type RecoveryPhase = "saved" | "truncated" | "done";

export interface RecoveryManifest {
  offset: number;
  sha256: string;
  lastSeq: number;
  phase: RecoveryPhase;
  tailBytes: number;
  tailFile: string;
  startedAt: string;
}

export function recoveryDir(journalPath: string): string {
  return join(dirname(journalPath), "recovery");
}

export function manifestPathFor(journalPath: string, lastSeq: number, offset: number): string {
  return join(recoveryDir(journalPath), `${lastSeq}-${offset}.manifest.json`);
}

export async function readManifest(path: string): Promise<RecoveryManifest | undefined> {
  try {
    return JSON.parse(await fs.readFile(path, "utf8")) as RecoveryManifest;
  } catch {
    return undefined;
  }
}

export async function writeManifest(
  path: string,
  manifest: RecoveryManifest,
  ops: DurableFsOps,
): Promise<void> {
  await writeFileDurable(path, Buffer.from(`${JSON.stringify(manifest, null, 2)}\n`, "utf8"), {
    ops,
  });
}

/** Đọc manifest recovery gần nhất (doctor / test resume). */
export async function readRecoveryManifest(
  journalPath: string,
  lastSeq: number,
  offset: number,
): Promise<RecoveryManifest | undefined> {
  return readManifest(manifestPathFor(journalPath, lastSeq, offset));
}
